export class NoRoomId extends Error {
  toString() {
    return "NoRoomId"
  }
}